import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight } from "lucide-react";

const DEMO_DRIVERS = [
  { name: "John", cdl: "Class A", equipment: "Reefer", status: "Available" },
  { name: "Maria", cdl: "Class A", equipment: "Dry Van", status: "Available" },
  { name: "Robert", cdl: "Class A", equipment: "Hazmat", status: "On Assignment" },
];

export const BrokerPrivateNetworkDemo = () => (
  <section data-testid="broker-private-network-demo-section" className="py-24 md:py-32 bg-white">
    <div className="max-w-4xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Reusable Relationships" title="Build a Network That Gets Stronger With Every Trip" align="center" testId="broker-private-network-demo" />
      <Reveal delay={0.15}>
        <p className="mt-6 text-rr-muted text-center max-w-2xl mx-auto leading-relaxed">
          When a broker finds drivers they prefer working with, RelayRigs allows those relationships to remain organized. Instead of starting over on every load, brokers can build a reusable network.
        </p>
      </Reveal>

      <Reveal delay={0.25}>
        <div data-testid="broker-private-network-demo-card" className="mt-10 bg-rr-surface border border-rr-line rounded-2xl p-6 md:p-8">
          <div className="flex items-center justify-between mb-5">
            <h3 className="font-heading font-bold text-rr-navy">Southeast Preferred Drivers</h3>
            <span data-testid="broker-private-network-demo-label" className="text-[11px] font-bold uppercase tracking-wide text-rr-muted bg-white border border-rr-line rounded-full px-2.5 py-1">Demo Data</span>
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            {DEMO_DRIVERS.map((d) => (
              <div key={d.name} data-testid={`broker-private-network-demo-driver-${d.name.toLowerCase()}`} className="bg-white border border-rr-line rounded-xl p-4">
                <p className="font-heading font-bold text-rr-navy">{d.name}</p>
                <p className="text-xs text-rr-muted mt-1">{d.cdl} · {d.equipment}</p>
                <span className={`inline-block mt-2 text-[11px] font-bold px-2 py-0.5 rounded-full ${d.status === "Available" ? "bg-rr-green/10 text-rr-green" : "bg-rr-muted/10 text-rr-muted"}`}>{d.status}</span>
              </div>
            ))}
          </div>
          <a href="/drivers" data-testid="broker-view-driver-network-button" className="mt-6 inline-flex items-center gap-2 text-rr-orange font-bold hover:underline">
            View Driver Network <ArrowRight size={15} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
